export const updateViewportHeight = () => {
  const contentSelector = '.g-content';
  const contentElement = document.querySelector(contentSelector);
  const contentHeight = contentElement.clientHeight;

  const windowHeight = window.innerHeight;

  if (windowHeight < contentHeight) {
    contentElement.setAttribute(
      'style',
      `bottom: ${contentHeight - windowHeight}px`,
    );
    window.scrollTo(0, 0);
  } else {
    contentElement.removeAttribute('style');
  }
};

export const setViewportHeight = () => {
  setTimeout(updateViewportHeight, 300);
};



// WEBPACK FOOTER //
// ./src/utils/rotationHelper.js